import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import axios from 'axios';

const AddArea = ({ show, onClose, selectedBranch, onSuccess  }) => {
    const [areaadd, setareaadd] = useState([{ id: Date.now(), area_name: '' }]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [errors, setErrors] = useState({});
    const [existingAreas, setExistingAreas] = useState([]);
    // Add new IP configuration
    const handleAddConfig = () => {
        setareaadd([...areaadd, { id: Date.now(), area_name: '' }]);
    };

    useEffect(() => {
        if (show && selectedBranch?.sno) {
            axios.get(`${baseURL}/managearea`, {
            params: { branch_name: selectedBranch.sno }
            })
            .then(response => {
            const areasFromAPI = response.data.data || [];
            console.log("areas:", areasFromAPI);
            // Map all area names to lowercase for case-insensitive comparison
            setExistingAreas(areasFromAPI.map(a => a.area_name.toLowerCase()));
            })
            .catch(error => {
            console.log('Failed to fetch existing areas:', error);
            setExistingAreas([]);
            });
        } else {
            setExistingAreas([]);
    }
    }, [show, selectedBranch, baseURL]);

    const handleInputChange = (id, value) => {
        setareaadd(prev =>
            prev.map(config =>
                config.id === id ? { ...config, area_name: value } : config
            )
        );

        // Clear the error as user types
        setErrors(prev => ({ ...prev, [id]: '' }));
    };
    
    // const handleSubmit = async () => {
    //     const newErrors = {};

    //     areaadd.forEach(item => {
    //         if (!item.area_name.trim()) {
    //             newErrors[item.id] = "This Field is required.";
    //         }
    //     });

    //     const names = areaadd.map(item => item.area_name.trim().toLowerCase());
    //     // const duplicatesInForm = names.filter((name, index) => names.indexOf(name) !== index);
    //     // if (duplicatesInForm.length > 0) {
    //     //     areaadd.forEach(item => {
    //     //         if (duplicatesInForm.includes(item.area_name.trim().toLowerCase())) {
    //     //             newErrors[item.id] = "Duplicate area name in form.";
    //     //         }
    //     //     });
    //     // }

    //     // Validate duplicates against existing areas fetched from server
    //     areaadd.forEach(item => {
    //         if (existingAreas.includes(item.area_name.trim().toLowerCase())) {
    //             newErrors[item.id] = "Area name already exists for this branch.";
    //         }
    //     });

    //     if (Object.keys(newErrors).length > 0) {
    //         setErrors(newErrors);
    //         return;
    //     }

    //     try {
    //         const areasPayload = areaadd.map(area => area.area_name.trim()).join(", ");
    //         await axios.post(`${baseURL}/managearea`, {
    //             branch_id: selectedBranch.branch_id,
    //             branch_name: selectedBranch.sno,
    //             area_name: areasPayload
    //         });
    //         toast.success("Areas created successfully!");
    //         // window.location.reload(); // or replace with a callback like onSuccess
    //          if (onSuccess) onSuccess();
    //         onClose();
    //     } catch (error) {
    //         console.log("Error creating area:", error);
    //         // alert("Failed to create areas. Please try again.");
    //     }
    // };

    // const handleSubmit = async () => {
    //     const newErrors = {};

    //     // Normalize existing areas for comparison
    //     const normalizedExisting = existingAreas.map(name => name.trim().toLowerCase());

    //     // Normalize current form area names
    //     const names = areaadd.map(item => item.area_name.trim().toLowerCase());

    //     // Check for empty fields
    //     areaadd.forEach(item => {
    //         if (!item.area_name.trim()) {
    //             newErrors[item.id] = "This Field is required.";
    //         }
    //     });

    //     // Check duplicates within the form
    //     const duplicatesInForm = names.filter((name, index) => names.indexOf(name) !== index);

    //     if (duplicatesInForm.length > 0) {
    //         areaadd.forEach(item => {
    //             const name = item.area_name.trim().toLowerCase();
    //             if (duplicatesInForm.includes(name)) {
    //                 // Only set if no previous error (like required)
    //                 if (!newErrors[item.id]) {
    //                     newErrors[item.id] = "Duplicate area name in form.";
    //                 }
    //             }
    //         });
    //     }

    //     // Check duplicates against existing areas
    //     areaadd.forEach(item => {
    //         const name = item.area_name.trim().toLowerCase();
    //         if (name && normalizedExisting.includes(name)) {
    //             if (!newErrors[item.id]) {
    //                 newErrors[item.id] = "Area name already exists for this branch.";
    //             }
    //         }
    //     });

    //     // If errors exist, show them and abort submission
    //     if (Object.keys(newErrors).length > 0) {
    //         setErrors(newErrors);
    //         return;
    //     }

    //     try {
    //         // Assuming you want to send each area name separately, not comma-joined
    //         // Otherwise, your backend must parse the string correctly
    //         const areasPayload = areaadd.map(area => area.area_name.trim());

    //         await axios.post(`${baseURL}/managearea`, {
    //             branch_id: selectedBranch.branch_id,
    //             branch_name: selectedBranch.sno,
    //             area_name: areasPayload,  // Send as array, adjust backend accordingly
    //         });

    //         toast.success("Areas created successfully!");
    //         if (onSuccess) onSuccess();
    //         onClose();

    //     } catch (error) {
    //         console.error("Error creating area:", error);
    //         // Optionally show an error toast here
    //     }
    // };

    const handleSubmit = async () => {
        const newErrors = {};

        const normalizedExisting = existingAreas.map(name => name.trim().toLowerCase());

        const trimmedAreas = areaadd.map(item => ({
            id: item.id,
            name: item.area_name.trim(),
            nameLower: item.area_name.trim().toLowerCase()
        }));

        // 1. Check for empty fields
        for (const area of trimmedAreas) {
            if (!area.name) {
                newErrors[area.id] = "This Field is required.";
            }
        }

        // 2. Check for duplicates in form
        const seenNames = new Set();
        for (const area of trimmedAreas) {
            if (seenNames.has(area.nameLower) && !newErrors[area.id]) {
                newErrors[area.id] = "Duplicate area name in form.";
            }
            seenNames.add(area.nameLower);
        }

        // 3. Check if any area already exists
        // for (const area of trimmedAreas) {
        //     if (!newErrors[area.id] && normalizedExisting.includes(area.nameLower)) {
        //         newErrors[area.id] = "This area already exists for this branch.";
        //     }
        // }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const newAreas = trimmedAreas.map(a => a.name);

        try {
            await axios.post(`${baseURL}/managearea`, {
                branch_id: selectedBranch.branch_id,
                branch_name: selectedBranch.sno,
                area_name: newAreas
            });

            toast.success("Areas created successfully!");
            if (onSuccess) onSuccess();
            onClose();

        } catch (error) {
            if (error.response && error.response.status === 409) {
                const responseMessage = error.response.data.message;

                // Backend confirms: all areas already exist
                if (responseMessage === 'No new areas created. All area names already exist for this branch.') {
                    const newErrors = {};
                    for (const area of trimmedAreas) {
                        newErrors[area.id] = "This Area Already Exists for this Branch.";
                    }
                    setErrors(newErrors);
                    return;
                }

                toast.error(responseMessage || "Conflict while creating areas.");
            } else if (error.response && error.response.status === 400) {
                toast.error("Validation error. Please check your inputs.");
            } else {
                toast.error("Failed to create areas. Please try again.");
                console.error("Unexpected error:", error);
            }
        }
    };

    // Delete an IP configuration
    const handleDeleteConfig = (id) => {
        setareaadd(areaadd.filter(config => config.id !== id));
    };
    const [isFocused] = useState(false);
    useEffect(() => {
        if (isFocused) {
            console.log('The input is focused!');
        }
    }, [isFocused]);

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Area</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <div className="row">
                                <label class="col-12 text-black fs-7">  {selectedBranch?.manage_branch_type === 1 ? "Franchise" : "Branch"}</label>
                                <label class="col-12 text-red font-w500 fs-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBranch?.branch_name || "N/A"}</label>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-3">
                            <div className='row'>
                                <div className='scroll-y mh-350px py-2'>
                                    <div className="col-lg-12 mb-3">
                                        <div className="mb-3">
                                            {areaadd.map(config => (
                                                <div key={config.id} data-repeater-item>
                                                    <div className="row">
                                                        <div className='col-lg-11 mb-2'>
                                                            <label className="text-black font-w500 fs-7">Add Area <span className="required">*</span></label>
                                                            <input type="text" className="form-control" placeholder="Enter Area" maxLength={100} value={config.area_name}
                                                            onChange={(e) => handleInputChange(config.id, e.target.value)}/>
                                                            {errors[config.id] && (<small className="text-danger">{errors[config.id]}</small>)}
                                                        </div>
                                                        <div className="col-lg-1 mb-2 px-1 py-1">
                                                            {areaadd.length > 1 && (
                                                                <button
                                                                    className="btn btn-danger mt-4 px-2 py-2"
                                                                    onClick={() => handleDeleteConfig(config.id)}
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title="Delete"
                                                                >
                                                                    <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-1 mt-1">
                                    <button
                                        className="btn btn-sm btn-primary py-1 px-2"
                                        onClick={handleAddConfig}
                                    >
                                        <span><i className="fa-solid fa-plus fs-7"></i></span>
                                        <span className='ms-2 fs-8'>Add More</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Area</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddArea;
